/* eslint-disable no-unused-vars */
import { Loader, Checkbox } from 'components';

const getItemName = {
  continent: 'continent_name',
  country: 'country_name',
  region: 'region_name',
  city: 'city',
};

export const SearchChooseContent = ({
  searchResult,
  isActiveItem,
  includeSet,
  excludeSet,
  childrenIsExcluded,
  toggleCheckedCountryOrRegion,
  selectedItemsAfterSearch$,
}) => {
  const { isLoading, data, isFetching } = searchResult;

  const handleOnChangeCheckBox = (item) => {
    const itemIsContained = selectedItemsAfterSearch$.value.has(item.id);
    const itemIsInclude = includeSet.has(item.id);
    const itemIsExclude = excludeSet.has(item.id);
    if (!itemIsContained && !itemIsInclude && !itemIsExclude) {
      selectedItemsAfterSearch$.value.set(item.id, item);
    }
    if (itemIsInclude || itemIsExclude) {
      selectedItemsAfterSearch$.value.delete(item.id, item);
    }
    toggleCheckedCountryOrRegion(item, 'id');
  };

  if (isFetching || !data) {
    return (
      <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
        <Loader.Local delay={100} />
      </div>
    );
  }

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '0 10px',
      }}
    >
      {data.map((item) => {
        return (
          <div
            key={item.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              minHeight: 40,
              width: '100%',
            }}
          >
            <Checkbox
              id={item.id}
              isChecked={isActiveItem(item, 'id')}
              name={item.id}
              style={{ marginRight: '16px', marginLeft: '8px' }}
              onChange={() => handleOnChangeCheckBox(item)}
              //isOpenGroup={childrenIsExcluded(item, 'id')}
            />
            <p>{item[getItemName[item.type]]}</p>
            <p style={{ marginLeft: 'auto' }}>{item.type}</p>
          </div>
        );
      })}
    </div>
  );
};
